<template>
  <div class="modal-calculations-container">
    <div>
    <h2 class="modal-calcutaions-calc-title">Calculations</h2>
    <table class="modal-calculations-items">
      <thead class="modal-calculations-header">
        <tr class="modal-calculations-title">
          <th data-testid="modal-calc-headers" v-for="header, index in this.header" :key="index">{{ header }}</th>
        </tr>
        <tr class="modal-calculations-subtitle">
          <th data-testid="modal-calc-units" v-for="unit, index in tableSubHeaders" :key="index">{{ unit }}</th>
        </tr>
      </thead>
      <tbody class="modal-calculations-body">
        <tr v-for="item, index in getSprinklerData" :key="index" data-testid="modal-calc-row">
          <td>
            <div data-testid="modal-calc-sprinkler">{{ index + 1 }}  {{ item.sprinkler }}</div>
          </td>
          <td>
            <div>{{ this.filterLength(item.xPosition) }}</div>
          </td>  
          <td>
            <div>{{ this.filterPressure(item.pipePres) }}</div>
          </td>  
          <td>
            <div>{{ this.filterPressure(item.sprinklerPres) }}</div>
          </td>
          <td>
            <div>{{ this.filterVelocity(item.velocity) }}</div>
          </td>  
          <td>
            <div>{{ this.filterEmitterFlow(item.flow) }}</div>
          </td>       
        </tr>
      </tbody>
    </table>
    </div>
    <div class="modal-calculations-button-holder">
      <button data-testid="modal-calculations-button" @click="this.hideModal" class="modal-calculations-button">DONE</button>
    </div>
  </div>
</template>
<script>
import * as UnitConversion from '@/services/UnitConversionService.js';
import { useModalStore } from '../store/ModalStore'; 
import { useSettingsStore } from '@/store/SettingsStore';
import { useInputStore } from '@/store/InputStore';
import { useSprinklerStore } from '@/store/SprinklerStore';
export default {
  data () {
    return {
      header: [
        ' ',
        'X Position',
        'Pipe Pres.',
        'Sprinkler Pres.',
        'Velocity',
        'Flow'
      ],
      units: [
        ' ',
        'ft',
        'psi',
        'psi',
        'ft/s',
        'US gpm'
      ],
      events: [],
      sprinklerData: {},
    };
  },
  computed: {
    tableSubHeaders () {
      const settingsStore = useSettingsStore();
      return [
        '',
        settingsStore.getLengthUnit,
        settingsStore.getPressureUnit,
        settingsStore.getPressureUnit,
        settingsStore.getVelocityUnit,
        settingsStore.getEmitterFlowUnit
      ];
    },
    getEvents () {
      return this.events;
    },
    getSprinklerData () {
      // Integrating calc data
      const sprinklerStore = useSprinklerStore();
      const modelId = sprinklerStore.getModelSelectedId;
      const plateId = sprinklerStore.getPlateSelectedId;
      const nozzleId = sprinklerStore.getNozzleSelectedId;
      const model = sprinklerStore.getModels.find((element) => element.id === modelId);
      const plate = sprinklerStore.getPlates.find((element) => element.id === plateId);
      const nozzle = sprinklerStore.getNozzles.find((element) => element.id === nozzleId);
      let calculationData = [];
      const segments = this.getCalcData.segments.filter((segment) => segment.nozzleId != null);
      const endIndex = segments.length - 1;
      segments.forEach((seg, index) => {
        if (seg.nozzleId != null || index === 0 || index === endIndex) {
          calculationData.push({
            sprinkler: model.name + ' ' + plate.name + ' ' + nozzle.name,
            xPosition: seg.xPosition,
            pipePres: seg.sprinklerPressure,
            sprinklerPres: seg.sprinklerPressure,
            velocity: seg.velocity,
            flow: seg.nozzleFlow         
          });
        }
      });
      return calculationData;
    },
    getCalcData () {
      return useInputStore().getCalcData;
    }
  },
  methods: {
    hideModal () {
      useModalStore().hideModal();
    },
    filterLength (length) {
      return (UnitConversion.FilterLength(length, useSettingsStore().getLengthUnit)).toFixed(2);
    },
    filterVelocity (velocity) {
      return (UnitConversion.FilterVelocity(velocity, useSettingsStore().getVelocityUnit)).toFixed(2);
    },
    filterPressure (pressure) {
      return (UnitConversion.FilterPressure(pressure, useSettingsStore().getPressureUnit)).toFixed(2);
    },
    filterEmitterFlow (flow) {
      return (UnitConversion.FilterEmitterFlow(flow, useSettingsStore().getEmitterFlowUnit)).toFixed(2);
    },
  }
};
</script>

<style scoped>
.modal-calcutaions-calc-title {
  margin: 0;
}
.modal-calculations-container {
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  padding: 1rem;
}
.modal-calculations-header {
  top: -1rem;
  position: sticky;
  background-color: #fafafa;
}
tr td div {
  padding: 0px 0;
}
tr:hover td:first-child div {
  background-color: #3875AF;
  color: white;
}
tr:hover td:not(first-child) div {
  background-color: #D5E5F1;
  color: black;
}
tr td:not(first-child) div {
  background-color: #fafafa;
  height: 30px;
}
tr td:first-child div {
  height: 30px;
  text-align: left;
  border-radius: 15px 0 0 15px;
  width: 140px;
  padding: 0 10px;
}
tr td:last-child div {
  height: 30px;
  text-align: center;
  border-radius: 0px 15px 15px 0px;
  padding-left: 15px;
}
th:last-child,
td:last-child {
  border-right: 0px solid darkgray;
}
td {
  font-size: small;
  width: 6vw;
  text-align: center;
  border-right: 0px solid darkgray;
}
.modal-calculations-items {
  width: 100%;
  border-spacing: 0;
}
.modal-calculations-subtitle {
  border: 1px solid #D5D5D5;
  text-align: right;
  padding: 5px 15px 5px 5px;
  font-size: .76em;
}
.modal-calculations-title {
  font-size: .8em;
  line-height: 1.3em;
  border: 0.5px solid lightgray;
  border-bottom: 1px solid gray;
  padding: 10px 3px 10px 3px;
}
.modal-calculations-body td {
  padding-top: 3px;
  padding-bottom: 3px;
  border-right: 0.5px solid lightgray;
}
.modal-calculations-body div {
  font-size: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: .9em;
  background-color: whitesmoke;
}
.modal-calculations-button {
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: var(--nelson-green);
  border: none;
}
.modal-calculations-button-holder {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 5px;
}
th {
  border-top: 1px solid #D5D5D5;
}
</style>
